module.exports = __webpack_public_path__ + "img/edit-class.373666b6.png";